import {ITourService, TourEvents} from "./ITourService";
import {startTour} from "../tours/smap-tour";
import {LTServices} from "../lt-ng/lt-services";
import IMapService = LTServices.IMapService;


export class TourService implements ITourService {
    public static $inject = ['$rootScope', 'landcareMapService'];
    constructor(protected $rootScope: ng.IRootScopeService, protected mapService: IMapService) {
        $rootScope.$on(TourEvents.start, () => this.startTour());
    }

    protected _tourLoading = false;

    isTourLoading(): boolean {
        return this._tourLoading;
    }

    startTour() {
        this._tourLoading = true;
        startTour(this.mapService).then(() => {
            this._tourLoading = false
        }, (error) => {
            console.log(error);
            this._tourLoading = false;
        });
    }
}
